module.exports = __webpack_public_path__ + "81d98dc20940a1f3ea8520e5e827c398.svg";